[
    {
        "TITLE_EN": "Afghanistan",
        "TITLE_FR": "Afghanistan",
        "TITLE_ES": "Afganistán",
        "TITLE_RU": "Афганистан",
        "TITLE_ZH": "阿富汗",
        "TITLE_AR": "أفغانستان",
        "CODE": "AF"
    },
    {
        "TITLE_EN": "Albania",
        "TITLE_FR": "Albanie",
        "TITLE_ES": "Albania",
        "TITLE_RU": "Албания",
        "TITLE_ZH": "阿尔巴尼亚",
        "TITLE_AR": "ألبانيا",
        "CODE": "AL"
    },
    {
        "TITLE_EN": "Algeria",
        "TITLE_FR": "Algérie",
        "TITLE_ES": "Argelia",
        "TITLE_RU": "Алжир",
        "TITLE_ZH": "阿尔及利亚",
        "TITLE_AR": "الجزائر",
        "CODE": "DZ"
    },
    {
        "TITLE_EN": "Andorra",
        "TITLE_FR": "Andorre",
        "TITLE_ES": "Andorra",
        "TITLE_RU": "Андорра",
        "TITLE_ZH": "安道尔",
        "TITLE_AR": "أندورا",
        "CODE": "AD"
    },
    {
        "TITLE_EN": "Angola",
        "TITLE_FR": "Angola",
        "TITLE_ES": "Angola",
        "TITLE_RU": "Ангола",
        "TITLE_ZH": "安哥拉",
        "TITLE_AR": "أنغولا",
        "CODE": "AO"
    },
    {
        "TITLE_EN": "Antigua and Barbuda",
        "TITLE_FR": "Antigua-et-Barbuda",
        "TITLE_ES": "Antigua y Barbuda",
        "TITLE_RU": "Антигуа и Барбуда",
        "TITLE_ZH": "安提瓜和巴布达",
        "TITLE_AR": "أنتيغوا وبربودا",
        "CODE": "AG"
    },
    {
        "TITLE_EN": "Argentina",
        "TITLE_FR": "Argentine",
        "TITLE_ES": "Argentina",
        "TITLE_RU": "Аргентина",
        "TITLE_ZH": "阿根廷",
        "TITLE_AR": "الأرجنتين",
        "CODE": "AR"
    },
    {
        "TITLE_EN": "Armenia",
        "TITLE_FR": "Arménie",
        "TITLE_ES": "Armenia",
        "TITLE_RU": "Армения",
        "TITLE_ZH": "亚美尼亚",
        "TITLE_AR": "أرمينيا",
        "CODE": "AM"
    },
    {
        "TITLE_EN": "Australia",
        "TITLE_FR": "Australie",
        "TITLE_ES": "Australia",
        "TITLE_RU": "Австралия",
        "TITLE_ZH": "澳大利亚",
        "TITLE_AR": "أستراليا",
        "CODE": "AU"
    },
    {
        "TITLE_EN": "Austria",
        "TITLE_FR": "Autriche",
        "TITLE_ES": "Austria",
        "TITLE_RU": "Австрия",
        "TITLE_ZH": "奥地利",
        "TITLE_AR": "النمسا",
        "CODE": "AT"
    },
    {
        "TITLE_EN": "Azerbaijan",
        "TITLE_FR": "Azerbaïdjan",
        "TITLE_ES": "Azerbaiyán",
        "TITLE_RU": "Азербайджан",
        "TITLE_ZH": "阿塞拜疆",
        "TITLE_AR": "أذربيجان",
        "CODE": "AZ"
    },
    {
        "TITLE_EN": "Bahamas",
        "TITLE_FR": "Bahamas",
        "TITLE_ES": "Bahamas",
        "TITLE_RU": "Багамские Острова",
        "TITLE_ZH": "巴哈马",
        "TITLE_AR": "جزر البهاما",
        "CODE": "BS"
    },
    {
        "TITLE_EN": "Bahrain",
        "TITLE_FR": "Bahreïn",
        "TITLE_ES": "Bahrein",
        "TITLE_RU": "Бахрейн",
        "TITLE_ZH": "巴林",
        "TITLE_AR": "البحرين",
        "CODE": "BH"
    },
    {
        "TITLE_EN": "Bangladesh",
        "TITLE_FR": "Bangladesh",
        "TITLE_ES": "Bangladesh",
        "TITLE_RU": "Бангладеш",
        "TITLE_ZH": "孟加拉国",
        "TITLE_AR": "بنغلاديش",
        "CODE": "BD"
    },
    {
        "TITLE_EN": "Barbados",
        "TITLE_FR": "Barbade",
        "TITLE_ES": "Barbados",
        "TITLE_RU": "Барбадос",
        "TITLE_ZH": "巴巴多斯",
        "TITLE_AR": "بربادوس",
        "CODE": "BB"
    },
    {
        "TITLE_EN": "Belarus",
        "TITLE_FR": "Bélarus",
        "TITLE_ES": "Belarús",
        "TITLE_RU": "Беларусь",
        "TITLE_ZH": "白俄罗斯",
        "TITLE_AR": "بيلاروس",
        "CODE": "BY"
    },
    {
        "TITLE_EN": "Belgium",
        "TITLE_FR": "Belgique",
        "TITLE_ES": "Bélgica",
        "TITLE_RU": "Бельгия",
        "TITLE_ZH": "比利时",
        "TITLE_AR": "بلجيكا",
        "CODE": "BE"
    },
    {
        "TITLE_EN": "Belize",
        "TITLE_FR": "Belize",
        "TITLE_ES": "Belice",
        "TITLE_RU": "Белиз",
        "TITLE_ZH": "伯利兹",
        "TITLE_AR": "بليز",
        "CODE": "BZ"
    },
    {
        "TITLE_EN": "Benin",
        "TITLE_FR": "Bénin",
        "TITLE_ES": "Benin",
        "TITLE_RU": "Бенин",
        "TITLE_ZH": "贝宁",
        "TITLE_AR": "بنن",
        "CODE": "BJ"
    },
    {
        "TITLE_EN": "Bhutan",
        "TITLE_FR": "Bhoutan",
        "TITLE_ES": "Bhután",
        "TITLE_RU": "Бутан",
        "TITLE_ZH": "不丹",
        "TITLE_AR": "بوتان",
        "CODE": "BT"
    },
    {
        "TITLE_EN": "Bolivia (Plurinational State of)",
        "TITLE_FR": "Bolivie (État plurinational de)",
        "TITLE_ES": "Bolivia (Estado Plurinacional de)",
        "TITLE_RU": "Боливия (Многонациональное Государство)",
        "TITLE_ZH": "玻利维亚(多民族国)",
        "TITLE_AR": "بوليفيا(دولة - متعددة القوميات)",
        "CODE": "BO"
    },
    {
        "TITLE_EN": "Bosnia and Herzegovina",
        "TITLE_FR": "Bosnie-Herzégovine",
        "TITLE_ES": "Bosnia y Herzegovina",
        "TITLE_RU": "Босния и Герцеговина",
        "TITLE_ZH": "波斯尼亚和黑塞哥维那",
        "TITLE_AR": "البوسنة والهرسك",
        "CODE": "BA"
    },
    {
        "TITLE_EN": "Botswana",
        "TITLE_FR": "Botswana",
        "TITLE_ES": "Botswana",
        "TITLE_RU": "Ботсвана",
        "TITLE_ZH": "博茨瓦纳",
        "TITLE_AR": "بوتسوانا",
        "CODE": "BW"
    },
    {
        "TITLE_EN": "Brazil",
        "TITLE_FR": "Brésil",
        "TITLE_ES": "Brasil",
        "TITLE_RU": "Бразилия",
        "TITLE_ZH": "巴西",
        "TITLE_AR": "البرازيل",
        "CODE": "BR"
    },
    {
        "TITLE_EN": "Brunei Darussalam",
        "TITLE_FR": "Brunéi Darussalam",
        "TITLE_ES": "Brunei Darussalam",
        "TITLE_RU": "Бруней-Даруссалам",
        "TITLE_ZH": "文莱达鲁萨兰国",
        "TITLE_AR": "بروني دار السلام",
        "CODE": "BN"
    },
    {
        "TITLE_EN": "Bulgaria",
        "TITLE_FR": "Bulgarie",
        "TITLE_ES": "Bulgaria",
        "TITLE_RU": "Болгария",
        "TITLE_ZH": "保加利亚",
        "TITLE_AR": "بلغاريا",
        "CODE": "BG"
    },
    {
        "TITLE_EN": "Burkina Faso",
        "TITLE_FR": "Burkina Faso",
        "TITLE_ES": "Burkina Faso",
        "TITLE_RU": "Буркина-Фасо",
        "TITLE_ZH": "布基纳法索",
        "TITLE_AR": "بوركينا فاسو",
        "CODE": "BF"
    },
    {
        "TITLE_EN": "Burundi",
        "TITLE_FR": "Burundi",
        "TITLE_ES": "Burundi",
        "TITLE_RU": "Бурунди",
        "TITLE_ZH": "布隆迪",
        "TITLE_AR": "بوروندي",
        "CODE": "BI"
    },
    {
        "TITLE_EN": "Cabo Verde",
        "TITLE_FR": "Cabo Verde",
        "TITLE_ES": "Cabo Verde",
        "TITLE_RU": "Кабо-Верде",
        "TITLE_ZH": "佛得角",
        "TITLE_AR": "كابو فيردي",
        "CODE": "CV"
    },
    {
        "TITLE_EN": "Cambodia",
        "TITLE_FR": "Cambodge",
        "TITLE_ES": "Camboya",
        "TITLE_RU": "Камбоджа",
        "TITLE_ZH": "柬埔寨",
        "TITLE_AR": "كمبوديا",
        "CODE": "KH"
    },
    {
        "TITLE_EN": "Cameroon",
        "TITLE_FR": "Cameroun",
        "TITLE_ES": "Camerún",
        "TITLE_RU": "Камерун",
        "TITLE_ZH": "喀麦隆",
        "TITLE_AR": "الكاميرون",
        "CODE": "CM"
    },
    {
        "TITLE_EN": "Canada",
        "TITLE_FR": "Canada",
        "TITLE_ES": "Canadá",
        "TITLE_RU": "Канада",
        "TITLE_ZH": "加拿大",
        "TITLE_AR": "كندا",
        "CODE": "CA"
    },
    {
        "TITLE_EN": "Central African Republic",
        "TITLE_FR": "République centrafricaine",
        "TITLE_ES": "República Centroafricana",
        "TITLE_RU": "Центральноафриканская Республика",
        "TITLE_ZH": "中非共和国",
        "TITLE_AR": "جمهورية أفريقيا الوسطى",
        "CODE": "CF"
    },
    {
        "TITLE_EN": "Chad",
        "TITLE_FR": "Tchad",
        "TITLE_ES": "Chad",
        "TITLE_RU": "Чад",
        "TITLE_ZH": "乍得",
        "TITLE_AR": "تشاد",
        "CODE": "TD"
    },
    {
        "TITLE_EN": "Chile",
        "TITLE_FR": "Chili",
        "TITLE_ES": "Chile",
        "TITLE_RU": "Чили",
        "TITLE_ZH": "智利",
        "TITLE_AR": "شيلي",
        "CODE": "CL"
    },
    {
        "TITLE_EN": "China",
        "TITLE_FR": "Chine",
        "TITLE_ES": "China",
        "TITLE_RU": "Китай",
        "TITLE_ZH": "中国",
        "TITLE_AR": "الصين",
        "CODE": "CN"
    },
    {
        "TITLE_EN": "Colombia",
        "TITLE_FR": "Colombie",
        "TITLE_ES": "Colombia",
        "TITLE_RU": "Колумбия",
        "TITLE_ZH": "哥伦比亚",
        "TITLE_AR": "كولومبيا",
        "CODE": "CO"
    },
    {
        "TITLE_EN": "Comoros",
        "TITLE_FR": "Comores",
        "TITLE_ES": "Comoras",
        "TITLE_RU": "Коморские Острова",
        "TITLE_ZH": "科摩罗",
        "TITLE_AR": "جزر القمر",
        "CODE": "KM"
    },
    {
        "TITLE_EN": "Congo",
        "TITLE_FR": "Congo",
        "TITLE_ES": "Congo",
        "TITLE_RU": "Конго",
        "TITLE_ZH": "刚果",
        "TITLE_AR": "الكونغو",
        "CODE": "CG"
    },
    {
        "TITLE_EN": "Cook Islands",
        "TITLE_FR": "Iles Cook",
        "TITLE_ES": "Islas Cook",
        "TITLE_RU": "Острова Кука",
        "TITLE_ZH": "库克群岛",
        "TITLE_AR": "جزر كوك",
        "CODE": "CK"
    },
    {
        "TITLE_EN": "Costa Rica",
        "TITLE_FR": "Costa Rica",
        "TITLE_ES": "Costa Rica",
        "TITLE_RU": "Коста-Рика",
        "TITLE_ZH": "哥斯达黎加",
        "TITLE_AR": "كوستاريكا",
        "CODE": "CR"
    },
    {
        "TITLE_EN": "Côte d'Ivoire",
        "TITLE_FR": "Côte d'Ivoire",
        "TITLE_ES": "Côte d'Ivoire",
        "TITLE_RU": "Кот-д'Ивуар",
        "TITLE_ZH": "科特迪瓦",
        "TITLE_AR": "كوت ديفوار",
        "CODE": "CI"
    },
    {
        "TITLE_EN": "Croatia",
        "TITLE_FR": "Croatie",
        "TITLE_ES": "Croacia",
        "TITLE_RU": "Хорватия",
        "TITLE_ZH": "克罗地亚",
        "TITLE_AR": "كرواتيا",
        "CODE": "HR"
    },
    {
        "TITLE_EN": "Cuba",
        "TITLE_FR": "Cuba",
        "TITLE_ES": "Cuba",
        "TITLE_RU": "Куба",
        "TITLE_ZH": "古巴",
        "TITLE_AR": "كوبا",
        "CODE": "CU"
    },
    {
        "TITLE_EN": "Cyprus",
        "TITLE_FR": "Chypre",
        "TITLE_ES": "Chipre",
        "TITLE_RU": "Кипр",
        "TITLE_ZH": "塞浦路斯",
        "TITLE_AR": "قبرص",
        "CODE": "CY"
    },
    {
        "TITLE_EN": "Czech Republic",
        "TITLE_FR": "République tchèque",
        "TITLE_ES": "República Checa",
        "TITLE_RU": "Чешская Республика",
        "TITLE_ZH": "捷克共和国",
        "TITLE_AR": "الجمهورية التشيكية",
        "CODE": "CZ"
    },
    {
        "TITLE_EN": "Democratic People's Republic of Korea",
        "TITLE_FR": "République populaire démocratique de Corée",
        "TITLE_ES": "República Popular Democrática de Corea",
        "TITLE_RU": "Корейская Народно-Демократическая Республика",
        "TITLE_ZH": "朝鲜民主主义人民共和国",
        "TITLE_AR": "جمهورية كوريا الشعبية الديمقراطية",
        "CODE": "KP"
    },
    {
        "TITLE_EN": "Democratic Republic of the Congo",
        "TITLE_FR": "République démocratique du Congo",
        "TITLE_ES": "República Democrática del Congo",
        "TITLE_RU": "Демократическая Республика Конго",
        "TITLE_ZH": "刚果民主共和国",
        "TITLE_AR": "جمهورية الكونغو الديمقراطية",
        "CODE": "CD"
    },
    {
        "TITLE_EN": "Denmark",
        "TITLE_FR": "Danemark",
        "TITLE_ES": "Dinamarca",
        "TITLE_RU": "Дания",
        "TITLE_ZH": "丹麦",
        "TITLE_AR": "الدانمرك",
        "CODE": "DK"
    },
    {
        "TITLE_EN": "Djibouti",
        "TITLE_FR": "Djibouti",
        "TITLE_ES": "Djibouti",
        "TITLE_RU": "Джибути",
        "TITLE_ZH": "吉布提",
        "TITLE_AR": "جيبوتي",
        "CODE": "DJ"
    },
    {
        "TITLE_EN": "Dominica",
        "TITLE_FR": "Dominique",
        "TITLE_ES": "Dominica",
        "TITLE_RU": "Доминика",
        "TITLE_ZH": "多米尼克",
        "TITLE_AR": "دومينيكا",
        "CODE": "DM"
    },
    {
        "TITLE_EN": "Dominican Republic",
        "TITLE_FR": "République dominicaine",
        "TITLE_ES": "República Dominicana",
        "TITLE_RU": "Доминиканская Республика",
        "TITLE_ZH": "多米尼加共和国",
        "TITLE_AR": "الجمهورية الدومينيكية",
        "CODE": "DO"
    },
    {
        "TITLE_EN": "Ecuador",
        "TITLE_FR": "Équateur",
        "TITLE_ES": "Ecuador",
        "TITLE_RU": "Эквадор",
        "TITLE_ZH": "厄瓜多尔",
        "TITLE_AR": "إكوادور",
        "CODE": "EC"
    },
    {
        "TITLE_EN": "Egypt",
        "TITLE_FR": "Égypte",
        "TITLE_ES": "Egipto",
        "TITLE_RU": "Египет",
        "TITLE_ZH": "埃及",
        "TITLE_AR": "مصر",
        "CODE": "EG"
    },
    {
        "TITLE_EN": "El Salvador",
        "TITLE_FR": "El Salvador",
        "TITLE_ES": "El Salvador",
        "TITLE_RU": "Сальвадор",
        "TITLE_ZH": "萨尔瓦多",
        "TITLE_AR": "السلفادور",
        "CODE": "SV"
    },
    {
        "TITLE_EN": "Equatorial Guinea",
        "TITLE_FR": "Guinée équatoriale",
        "TITLE_ES": "Guinea Ecuatorial",
        "TITLE_RU": "Экваториальная Гвинея",
        "TITLE_ZH": "赤道几内亚",
        "TITLE_AR": "غينيا الاستوائية",
        "CODE": "GQ"
    },
    {
        "TITLE_EN": "Eritrea",
        "TITLE_FR": "Erythrée",
        "TITLE_ES": "Eritrea",
        "TITLE_RU": "Эритрея",
        "TITLE_ZH": "厄立特里亚",
        "TITLE_AR": "إريتريا",
        "CODE": "ER"
    },
    {
        "TITLE_EN": "Estonia",
        "TITLE_FR": "Estonie",
        "TITLE_ES": "Estonia",
        "TITLE_RU": "Эстония",
        "TITLE_ZH": "爱沙尼亚",
        "TITLE_AR": "إستونيا",
        "CODE": "EE"
    },
    {
        "TITLE_EN": "Eswatini",
        "TITLE_FR": "Eswatini",
        "TITLE_ES": "Eswatini",
        "TITLE_RU": "Эсватини",
        "TITLE_ZH": "斯威士兰",
        "TITLE_AR": "إسواتيني",
        "CODE": "SZ"
    },
    {
        "TITLE_EN": "Ethiopia",
        "TITLE_FR": "Éthiopie",
        "TITLE_ES": "Etiopía",
        "TITLE_RU": "Эфиопия",
        "TITLE_ZH": "埃塞俄比亚",
        "TITLE_AR": "أثيوبيا",
        "CODE": "ET"
    },
    {
        "TITLE_EN": "Fiji",
        "TITLE_FR": "Fidji",
        "TITLE_ES": "Fiji",
        "TITLE_RU": "Фиджи",
        "TITLE_ZH": "斐济",
        "TITLE_AR": "فيجي",
        "CODE": "FJ"
    },
    {
        "TITLE_EN": "Finland",
        "TITLE_FR": "Finlande",
        "TITLE_ES": "Finlandia",
        "TITLE_RU": "Финляндия",
        "TITLE_ZH": "芬兰",
        "TITLE_AR": "فنلندا",
        "CODE": "FI"
    },
    {
        "TITLE_EN": "France",
        "TITLE_FR": "France",
        "TITLE_ES": "Francia",
        "TITLE_RU": "Франция",
        "TITLE_ZH": "法国",
        "TITLE_AR": "فرنسا",
        "CODE": "FR"
    },
    {
        "TITLE_EN": "Gabon",
        "TITLE_FR": "Gabon",
        "TITLE_ES": "Gabón",
        "TITLE_RU": "Габон",
        "TITLE_ZH": "加蓬",
        "TITLE_AR": "غابون",
        "CODE": "GA"
    },
    {
        "TITLE_EN": "Gambia (the)",
        "TITLE_FR": "Gambie (la)",
        "TITLE_ES": "Gambia",
        "TITLE_RU": "Гамбия",
        "TITLE_ZH": "冈比亚",
        "TITLE_AR": "غامبيا",
        "CODE": "GM"
    },
    {
        "TITLE_EN": "Georgia",
        "TITLE_FR": "Géorgie",
        "TITLE_ES": "Georgia",
        "TITLE_RU": "Грузия",
        "TITLE_ZH": "格鲁吉亚",
        "TITLE_AR": "جورجيا",
        "CODE": "GE"
    },
    {
        "TITLE_EN": "Germany",
        "TITLE_FR": "Allemagne",
        "TITLE_ES": "Alemania",
        "TITLE_RU": "Германия",
        "TITLE_ZH": "德国",
        "TITLE_AR": "ألمانيا",
        "CODE": "DE"
    },
    {
        "TITLE_EN": "Ghana",
        "TITLE_FR": "Ghana",
        "TITLE_ES": "Ghana",
        "TITLE_RU": "Гана",
        "TITLE_ZH": "加纳",
        "TITLE_AR": "غانا",
        "CODE": "GH"
    },
    {
        "TITLE_EN": "Greece",
        "TITLE_FR": "Grèce",
        "TITLE_ES": "Grecia",
        "TITLE_RU": "Греция",
        "TITLE_ZH": "希腊",
        "TITLE_AR": "اليونان",
        "CODE": "GR"
    },
    {
        "TITLE_EN": "Grenada",
        "TITLE_FR": "Grenade",
        "TITLE_ES": "Granada",
        "TITLE_RU": "Гренада",
        "TITLE_ZH": "格林纳达",
        "TITLE_AR": "غرينادا",
        "CODE": "GD"
    },
    {
        "TITLE_EN": "Guatemala",
        "TITLE_FR": "Guatemala",
        "TITLE_ES": "Guatemala",
        "TITLE_RU": "Гватемала",
        "TITLE_ZH": "危地马拉",
        "TITLE_AR": "غواتيمالا",
        "CODE": "GT"
    },
    {
        "TITLE_EN": "Guinea",
        "TITLE_FR": "Guinée",
        "TITLE_ES": "Guinea",
        "TITLE_RU": "Гвинея",
        "TITLE_ZH": "几内亚",
        "TITLE_AR": "غينيا",
        "CODE": "GN"
    },
    {
        "TITLE_EN": "Guinea-Bissau",
        "TITLE_FR": "Guinée-Bissau",
        "TITLE_ES": "Guinea-Bissau",
        "TITLE_RU": "Гвинея-Бисау",
        "TITLE_ZH": "几内亚比绍",
        "TITLE_AR": "غينيا-بيساو",
        "CODE": "GW"
    },
    {
        "TITLE_EN": "Guyana",
        "TITLE_FR": "Guyana",
        "TITLE_ES": "Guyana",
        "TITLE_RU": "Гайана",
        "TITLE_ZH": "圭亚那",
        "TITLE_AR": "غيانا",
        "CODE": "GY"
    },
    {
        "TITLE_EN": "Haiti",
        "TITLE_FR": "Haïti",
        "TITLE_ES": "Haití",
        "TITLE_RU": "Гаити",
        "TITLE_ZH": "海地",
        "TITLE_AR": "هايتي",
        "CODE": "HT"
    },
    {
        "TITLE_EN": "Holy See",
        "TITLE_FR": "Saint-Siège",
        "TITLE_ES": "Santa Sede ",
        "TITLE_RU": "Святой Престол",
        "TITLE_ZH": "教廷",
        "TITLE_AR": "الكرسي الرسولي",
        "CODE": "VA"
    },
    {
        "TITLE_EN": "Honduras",
        "TITLE_FR": "Honduras",
        "TITLE_ES": "Honduras",
        "TITLE_RU": "Гондурас",
        "TITLE_ZH": "洪都拉斯",
        "TITLE_AR": "هندوراس",
        "CODE": "HN"
    },
    {
        "TITLE_EN": "Hong Kong, China",
        "TITLE_FR": "Hong Kong (Chine)",
        "TITLE_ES": "Hong Kong (China)",
        "TITLE_RU": "Гонконг, Китай",
        "TITLE_ZH": "香港 (特区)，中国",
        "TITLE_AR": "إقليم هونغ كونغ، الصين",
        "CODE": "HK"
    },
    {
        "TITLE_EN": "Hungary",
        "TITLE_FR": "la Hongrie",
        "TITLE_ES": "Hungría",
        "TITLE_RU": "Венгрия",
        "TITLE_ZH": "匈牙利",
        "TITLE_AR": "هنغاريا",
        "CODE": "HU"
    },
    {
        "TITLE_EN": "Iceland",
        "TITLE_FR": "Islande",
        "TITLE_ES": "Islandia",
        "TITLE_RU": "Исландия",
        "TITLE_ZH": "冰岛",
        "TITLE_AR": "إيسلندا",
        "CODE": "IS"
    },
    {
        "TITLE_EN": "India",
        "TITLE_FR": "Inde",
        "TITLE_ES": "India",
        "TITLE_RU": "Индия",
        "TITLE_ZH": "印度",
        "TITLE_AR": "الهند",
        "CODE": "IN"
    },
    {
        "TITLE_EN": "Indonesia",
        "TITLE_FR": "Indonésie",
        "TITLE_ES": "Indonesia",
        "TITLE_RU": "Индонезия",
        "TITLE_ZH": "印度尼西亚",
        "TITLE_AR": "إندونيسيا",
        "CODE": "ID"
    },
    {
        "TITLE_EN": "Iran (Islamic Republic of)",
        "TITLE_FR": "Iran (République islamique d')",
        "TITLE_ES": "Irán (República Islámica del)",
        "TITLE_RU": "Иран (Исламская Республика Иран)",
        "TITLE_ZH": "伊朗(伊斯兰共和国)",
        "TITLE_AR": "إيران(جمهورية-الإسلامية)",
        "CODE": "IR"
    },
    {
        "TITLE_EN": "Iraq",
        "TITLE_FR": "Iraq",
        "TITLE_ES": "Iraq",
        "TITLE_RU": "Ирак",
        "TITLE_ZH": "伊拉克",
        "TITLE_AR": "العراق",
        "CODE": "IQ"
    },
    {
        "TITLE_EN": "Ireland",
        "TITLE_FR": "Irlande",
        "TITLE_ES": "Irlanda",
        "TITLE_RU": "Ирландия",
        "TITLE_ZH": "爱尔兰",
        "TITLE_AR": "إيرلندا",
        "CODE": "IE"
    },
    {
        "TITLE_EN": "Israel",
        "TITLE_FR": "Israël",
        "TITLE_ES": "Israel",
        "TITLE_RU": "Израиль",
        "TITLE_ZH": "以色列",
        "TITLE_AR": "إسرائيل",
        "CODE": "IL"
    },
    {
        "TITLE_EN": "Italy",
        "TITLE_FR": "Italie",
        "TITLE_ES": "Italia",
        "TITLE_RU": "Италия",
        "TITLE_ZH": "意大利",
        "TITLE_AR": "إيطاليا",
        "CODE": "IT"
    },
    {
        "TITLE_EN": "Jamaica",
        "TITLE_FR": "Jamaïque",
        "TITLE_ES": "Jamaica",
        "TITLE_RU": "Ямайка",
        "TITLE_ZH": "牙买加",
        "TITLE_AR": "جامايكا",
        "CODE": "JM"
    },
    {
        "TITLE_EN": "Japan",
        "TITLE_FR": "Japon",
        "TITLE_ES": "Japón",
        "TITLE_RU": "Япония",
        "TITLE_ZH": "日本",
        "TITLE_AR": "اليابان",
        "CODE": "JP"
    },
    {
        "TITLE_EN": "Jordan",
        "TITLE_FR": "Jordanie",
        "TITLE_ES": "Jordania",
        "TITLE_RU": "Иордания",
        "TITLE_ZH": "约旦",
        "TITLE_AR": "الأردن",
        "CODE": "JO"
    },
    {
        "TITLE_EN": "Kazakhstan",
        "TITLE_FR": "Kazakhstan",
        "TITLE_ES": "Kazajstán",
        "TITLE_RU": "Казахстан",
        "TITLE_ZH": "哈萨克斯坦",
        "TITLE_AR": "كازاخستان",
        "CODE": "KZ"
    },
    {
        "TITLE_EN": "Kenya",
        "TITLE_FR": "Kenya",
        "TITLE_ES": "Kenya",
        "TITLE_RU": "Кения",
        "TITLE_ZH": "肯尼亚",
        "TITLE_AR": "كينيا",
        "CODE": "KE"
    },
    {
        "TITLE_EN": "Kiribati",
        "TITLE_FR": "Kiribati",
        "TITLE_ES": "Kiribati",
        "TITLE_RU": "Кирибати",
        "TITLE_ZH": "基里巴斯",
        "TITLE_AR": "كيريباتي",
        "CODE": "KI"
    },
    {
        "TITLE_EN": "Kuwait",
        "TITLE_FR": "Koweït",
        "TITLE_ES": "Kuwait",
        "TITLE_RU": "Кувейт",
        "TITLE_ZH": "科威特",
        "TITLE_AR": "الكويت",
        "CODE": "KW"
    },
    {
        "TITLE_EN": "Kyrgyzstan",
        "TITLE_FR": "Kirghizistan",
        "TITLE_ES": "Kirguistán",
        "TITLE_RU": "Кыргызстан",
        "TITLE_ZH": "吉尔吉斯斯坦",
        "TITLE_AR": "قيرغيزستان",
        "CODE": "KG"
    },
    {
        "TITLE_EN": "Lao People's Democratic Republic",
        "TITLE_FR": "République démocratique populaire lao",
        "TITLE_ES": "República Democrática Popular Lao",
        "TITLE_RU": "Лаосская Народно-Демократическая Республика",
        "TITLE_ZH": "老挝人民民主共和国",
        "TITLE_AR": "جمهورية لاو الديمقراطية الشعبية",
        "CODE": "LA"
    },
    {
        "TITLE_EN": "Latvia",
        "TITLE_FR": "Lettonie",
        "TITLE_ES": "Letonia",
        "TITLE_RU": "Латвия",
        "TITLE_ZH": "拉脱维亚",
        "TITLE_AR": "لاتفيا",
        "CODE": "LV"
    },
    {
        "TITLE_EN": "Lebanon",
        "TITLE_FR": "Liban",
        "TITLE_ES": "Líbano",
        "TITLE_RU": "Ливан",
        "TITLE_ZH": "黎巴嫩",
        "TITLE_AR": "لبنان",
        "CODE": "LB"
    },
    {
        "TITLE_EN": "Lesotho",
        "TITLE_FR": "Lesotho",
        "TITLE_ES": "Lesotho",
        "TITLE_RU": "Лесото",
        "TITLE_ZH": "莱索托",
        "TITLE_AR": "ليسوتو",
        "CODE": "LS"
    },
    {
        "TITLE_EN": "Liberia",
        "TITLE_FR": "Libéria",
        "TITLE_ES": "Liberia",
        "TITLE_RU": "Либерия",
        "TITLE_ZH": "利比里亚",
        "TITLE_AR": "ليبيريا",
        "CODE": "LR"
    },
    {
        "TITLE_EN": "Libya",
        "TITLE_FR": "Libye",
        "TITLE_ES": "Libia",
        "TITLE_RU": "Ливия",
        "TITLE_ZH": "利比亚",
        "TITLE_AR": "ليبيا",
        "CODE": "LY"
    },
    {
        "TITLE_EN": "Liechtenstein",
        "TITLE_FR": "Liechtenstein",
        "TITLE_ES": "Liechtenstein",
        "TITLE_RU": "Лихтенштейн",
        "TITLE_ZH": "列支敦士登",
        "TITLE_AR": "ليختنشتاين",
        "CODE": "LI"
    },
    {
        "TITLE_EN": "Lithuania",
        "TITLE_FR": "Lituanie",
        "TITLE_ES": "Lituania",
        "TITLE_RU": "Литва",
        "TITLE_ZH": "立陶宛",
        "TITLE_AR": "ليتوانيا",
        "CODE": "LT"
    },
    {
        "TITLE_EN": "Luxembourg",
        "TITLE_FR": "Luxembourg",
        "TITLE_ES": "Luxemburgo",
        "TITLE_RU": "Люксембург",
        "TITLE_ZH": "卢森堡",
        "TITLE_AR": "لكسمبرغ",
        "CODE": "LU"
    },
    {
        "TITLE_EN": "Madagascar",
        "TITLE_FR": "Madagascar",
        "TITLE_ES": "Madagascar",
        "TITLE_RU": "Мадагаскар",
        "TITLE_ZH": "马达加斯加",
        "TITLE_AR": "مدغشقر",
        "CODE": "MG"
    },
    {
        "TITLE_EN": "Malawi",
        "TITLE_FR": "Malawi",
        "TITLE_ES": "Malawi",
        "TITLE_RU": "Малави",
        "TITLE_ZH": "马拉维",
        "TITLE_AR": "ملاوي",
        "CODE": "MW"
    },
    {
        "TITLE_EN": "Malaysia",
        "TITLE_FR": "Malaisie",
        "TITLE_ES": "Malasia",
        "TITLE_RU": "Малайзия",
        "TITLE_ZH": "马来西亚",
        "TITLE_AR": "ماليزيا",
        "CODE": "MY"
    },
    {
        "TITLE_EN": "Maldives",
        "TITLE_FR": "Maldives",
        "TITLE_ES": "Maldivas",
        "TITLE_RU": "Мальдивские Острова",
        "TITLE_ZH": "马尔代夫",
        "TITLE_AR": "ملديف",
        "CODE": "MV"
    },
    {
        "TITLE_EN": "Mali",
        "TITLE_FR": "Mali",
        "TITLE_ES": "Malí",
        "TITLE_RU": "Мали",
        "TITLE_ZH": "马里",
        "TITLE_AR": "مالي",
        "CODE": "ML"
    },
    {
        "TITLE_EN": "Malta",
        "TITLE_FR": "Malte",
        "TITLE_ES": "Malta",
        "TITLE_RU": "Мальта",
        "TITLE_ZH": "马耳他",
        "TITLE_AR": "مالطة",
        "CODE": "MT"
    },
    {
        "TITLE_EN": "Marshall Islands",
        "TITLE_FR": "Iles Marshall",
        "TITLE_ES": "Islas Marshall",
        "TITLE_RU": "Маршалловы Острова",
        "TITLE_ZH": "马绍尔群岛",
        "TITLE_AR": "جزر مارشال",
        "CODE": "MH"
    },
    {
        "TITLE_EN": "Mauritania",
        "TITLE_FR": "Mauritanie",
        "TITLE_ES": "Mauritania",
        "TITLE_RU": "Мавритания",
        "TITLE_ZH": "毛里塔尼亚",
        "TITLE_AR": "موريتانيا",
        "CODE": "MR"
    },
    {
        "TITLE_EN": "Mauritius",
        "TITLE_FR": "Maurice",
        "TITLE_ES": "Mauricio",
        "TITLE_RU": "Маврикий",
        "TITLE_ZH": "毛里求斯",
        "TITLE_AR": "موريشيوس",
        "CODE": "MU"
    },
    {
        "TITLE_EN": "Mexico",
        "TITLE_FR": "Mexique",
        "TITLE_ES": "México",
        "TITLE_RU": "Мексика",
        "TITLE_ZH": "墨西哥",
        "TITLE_AR": "المكسيك",
        "CODE": "MX"
    },
    {
        "TITLE_EN": "Micronesia (Federated States of)",
        "TITLE_FR": "Micronésie (Etats fédérés de)",
        "TITLE_ES": "Micronesia (Estados Federados de)",
        "TITLE_RU": "Микронезия(Федеративные Штаты Микронезии)",
        "TITLE_ZH": "密克罗尼西亚(联邦)",
        "TITLE_AR": "ميكرونيزيا(ولايات - الموحدة)",
        "CODE": "FM"
    },
    {
        "TITLE_EN": "Monaco",
        "TITLE_FR": "Monaco",
        "TITLE_ES": "Mónaco",
        "TITLE_RU": "Монако",
        "TITLE_ZH": "摩纳哥",
        "TITLE_AR": "موناكو",
        "CODE": "MC"
    },
    {
        "TITLE_EN": "Mongolia",
        "TITLE_FR": "Mongolie",
        "TITLE_ES": "Mongolia",
        "TITLE_RU": "Монголия",
        "TITLE_ZH": "蒙古",
        "TITLE_AR": "منغوليا",
        "CODE": "MN"
    },
    {
        "TITLE_EN": "Montenegro",
        "TITLE_FR": "Monténégro ",
        "TITLE_ES": "Montenegro",
        "TITLE_RU": "Черногория",
        "TITLE_ZH": "黑山",
        "TITLE_AR": "الجبل الأسود",
        "CODE": "ME"
    },
    {
        "TITLE_EN": "Morocco",
        "TITLE_FR": "Maroc",
        "TITLE_ES": "Marruecos",
        "TITLE_RU": "Марокко",
        "TITLE_ZH": "摩洛哥",
        "TITLE_AR": "المغرب",
        "CODE": "MA"
    },
    {
        "TITLE_EN": "Mozambique",
        "TITLE_FR": "Mozambique",
        "TITLE_ES": "Mozambique",
        "TITLE_RU": "Мозамбик",
        "TITLE_ZH": "莫桑比克",
        "TITLE_AR": "موزامبيق",
        "CODE": "MZ"
    },
    {
        "TITLE_EN": "Myanmar",
        "TITLE_FR": "Myanmar",
        "TITLE_ES": "Myanmar",
        "TITLE_RU": "Мьянма",
        "TITLE_ZH": "缅甸",
        "TITLE_AR": "ميانمار",
        "CODE": "MM"
    },
    {
        "TITLE_EN": "Namibia",
        "TITLE_FR": "Namibie",
        "TITLE_ES": "Namibia",
        "TITLE_RU": "Намибия",
        "TITLE_ZH": "纳米比亚",
        "TITLE_AR": "ناميبيا",
        "CODE": "NA"
    },
    {
        "TITLE_EN": "Nauru",
        "TITLE_FR": "Nauru",
        "TITLE_ES": "Nauru",
        "TITLE_RU": "Науру",
        "TITLE_ZH": "瑙鲁",
        "TITLE_AR": "ناورو",
        "CODE": "NR"
    },
    {
        "TITLE_EN": "Nepal",
        "TITLE_FR": "Népal",
        "TITLE_ES": "Nepal",
        "TITLE_RU": "Непал",
        "TITLE_ZH": "尼泊尔",
        "TITLE_AR": "نيبال",
        "CODE": "NP"
    },
    {
        "TITLE_EN": "Netherlands (Kingdom of the)",
        "TITLE_FR": "Pays-Bas (Royaume des)",
        "TITLE_ES": "Países Bajos (Reino de los)",
        "TITLE_RU": "Нидерланды (Королевство)",
        "TITLE_ZH": "荷兰王国",
        "TITLE_AR": "ندا (مملكة _)",
        "CODE": "NL"
    },
    {
        "TITLE_EN": "New Zealand",
        "TITLE_FR": "Nouvelle-Zélande",
        "TITLE_ES": "Nueva Zelandia",
        "TITLE_RU": "Новая Зеландия",
        "TITLE_ZH": "新西兰",
        "TITLE_AR": "نيوزيلندا",
        "CODE": "NZ"
    },
    {
        "TITLE_EN": "Nicaragua",
        "TITLE_FR": "Nicaragua",
        "TITLE_ES": "Nicaragua",
        "TITLE_RU": "Никарагуа",
        "TITLE_ZH": "尼加拉瓜",
        "TITLE_AR": "نيكاراغوا",
        "CODE": "NI"
    },
    {
        "TITLE_EN": "Niger",
        "TITLE_FR": "Niger",
        "TITLE_ES": "Níger ",
        "TITLE_RU": "Нигер",
        "TITLE_ZH": "尼日尔",
        "TITLE_AR": "النيجر",
        "CODE": "NE"
    },
    {
        "TITLE_EN": "Nigeria",
        "TITLE_FR": "Nigéria",
        "TITLE_ES": "Nigeria",
        "TITLE_RU": "Нигерия",
        "TITLE_ZH": "尼日利亚",
        "TITLE_AR": "نيجيريا",
        "CODE": "NG"
    },
    {
        "TITLE_EN": "Niue",
        "TITLE_FR": "Nioué",
        "TITLE_ES": "Niue",
        "TITLE_RU": "Ниуэ",
        "TITLE_ZH": "纽埃",
        "TITLE_AR": "نيوي",
        "CODE": "NU"
    },
    {
        "TITLE_EN": "North Macedonia",
        "TITLE_FR": "Macédoine du Nord",
        "TITLE_ES": "Macedonia del Norte",
        "TITLE_RU": "Северная Македония",
        "TITLE_ZH": "北马其顿",
        "TITLE_AR": "مقدونيا الشمالية",
        "CODE": "MK"
    },
    {
        "TITLE_EN": "Norway",
        "TITLE_FR": "Norvège",
        "TITLE_ES": "Noruega",
        "TITLE_RU": "Норвегия",
        "TITLE_ZH": "挪威",
        "TITLE_AR": "النرويج",
        "CODE": "NO"
    },
    {
        "TITLE_EN": "Oman",
        "TITLE_FR": "Oman",
        "TITLE_ES": "Omán",
        "TITLE_RU": "Оман",
        "TITLE_ZH": "阿曼",
        "TITLE_AR": "عمان",
        "CODE": "OM"
    },
    {
        "TITLE_EN": "Pakistan",
        "TITLE_FR": "Pakistan",
        "TITLE_ES": "Pakistán",
        "TITLE_RU": "Пакистан",
        "TITLE_ZH": "巴基斯坦",
        "TITLE_AR": "باكستان",
        "CODE": "PK"
    },
    {
        "TITLE_EN": "Palau",
        "TITLE_FR": "Palaos",
        "TITLE_ES": "Palau",
        "TITLE_RU": "Палау",
        "TITLE_ZH": "帕劳",
        "TITLE_AR": "بالاو",
        "CODE": "PW"
    },
    {
        "TITLE_EN": "Panama",
        "TITLE_FR": "Panama",
        "TITLE_ES": "Panamá",
        "TITLE_RU": "Панама",
        "TITLE_ZH": "巴拿马",
        "TITLE_AR": "بنما",
        "CODE": "PA"
    },
    {
        "TITLE_EN": "Papua New Guinea",
        "TITLE_FR": "Papouasie-Nouvelle-Guinée",
        "TITLE_ES": "Papua Nueva Guinea",
        "TITLE_RU": "Папуа-Новая Гвинея",
        "TITLE_ZH": "巴布亚新几内亚",
        "TITLE_AR": "بابوا غينيا الجديدة",
        "CODE": "PG"
    },
    {
        "TITLE_EN": "Paraguay",
        "TITLE_FR": "Paraguay",
        "TITLE_ES": "Paraguay",
        "TITLE_RU": "Парагвай",
        "TITLE_ZH": "巴拉圭",
        "TITLE_AR": "باراغواي",
        "CODE": "PY"
    },
    {
        "TITLE_EN": "Peru",
        "TITLE_FR": "Pérou",
        "TITLE_ES": "Perú",
        "TITLE_RU": "Перу",
        "TITLE_ZH": "秘鲁",
        "TITLE_AR": "بيرو",
        "CODE": "PE"
    },
    {
        "TITLE_EN": "Philippines",
        "TITLE_FR": "Philippines",
        "TITLE_ES": "Filipinas",
        "TITLE_RU": "Филиппины",
        "TITLE_ZH": "菲律宾",
        "TITLE_AR": "الفلبين",
        "CODE": "PH"
    },
    {
        "TITLE_EN": "Poland",
        "TITLE_FR": "Pologne",
        "TITLE_ES": "Polonia",
        "TITLE_RU": "Польша",
        "TITLE_ZH": "波兰",
        "TITLE_AR": "بولندا",
        "CODE": "PL"
    },
    {
        "TITLE_EN": "Portugal",
        "TITLE_FR": "Portugal",
        "TITLE_ES": "Portugal",
        "TITLE_RU": "Португалия",
        "TITLE_ZH": "葡萄牙",
        "TITLE_AR": "البرتغال",
        "CODE": "PT"
    },
    {
        "TITLE_EN": "Qatar",
        "TITLE_FR": "Qatar",
        "TITLE_ES": "Qatar",
        "TITLE_RU": "Катар",
        "TITLE_ZH": "卡塔尔",
        "TITLE_AR": "قطر",
        "CODE": "QA"
    },
    {
        "TITLE_EN": "Republic of Korea",
        "TITLE_FR": "République de Corée",
        "TITLE_ES": "República de Corea ",
        "TITLE_RU": "Республика Корея",
        "TITLE_ZH": "大韩民国",
        "TITLE_AR": "جمهورية كوريا",
        "CODE": "KR"
    },
    {
        "TITLE_EN": "Republic of Moldova",
        "TITLE_FR": "République de Moldova",
        "TITLE_ES": "República de Moldova",
        "TITLE_RU": "Республика Молдова",
        "TITLE_ZH": "摩尔多瓦共和国",
        "TITLE_AR": "جمهورية مولدوفا",
        "CODE": "MD"
    },
    {
        "TITLE_EN": "Romania",
        "TITLE_FR": "Roumanie",
        "TITLE_ES": "Rumania",
        "TITLE_RU": "Румыния",
        "TITLE_ZH": "罗马尼亚",
        "TITLE_AR": "رومانيا",
        "CODE": "RO"
    },
    {
        "TITLE_EN": "Russian Federation",
        "TITLE_FR": "Fédération de Russie",
        "TITLE_ES": "Federación de Rusia",
        "TITLE_RU": "Российская Федерация",
        "TITLE_ZH": "俄罗斯联邦",
        "TITLE_AR": "الاتحاد الروسي",
        "CODE": "RU"
    },
    {
        "TITLE_EN": "Rwanda",
        "TITLE_FR": "Rwanda",
        "TITLE_ES": "Rwanda",
        "TITLE_RU": "Руанда",
        "TITLE_ZH": "卢旺达",
        "TITLE_AR": "رواندا",
        "CODE": "RW"
    },
    {
        "TITLE_EN": "Saint Kitts and Nevis",
        "TITLE_FR": "Saint-Kitts-et-Nevis",
        "TITLE_ES": "Saint Kitts y Nevis",
        "TITLE_RU": "Сент-Китс и Невис",
        "TITLE_ZH": "圣基茨和尼维斯",
        "TITLE_AR": "سانت كيتس ونيفس",
        "CODE": "KN"
    },
    {
        "TITLE_EN": "Saint Lucia",
        "TITLE_FR": "Sainte-Lucie",
        "TITLE_ES": "Santa Lucía",
        "TITLE_RU": "Сент-Люсия",
        "TITLE_ZH": "圣卢西亚",
        "TITLE_AR": "سانت لوسيا",
        "CODE": "LC"
    },
    {
        "TITLE_EN": "Saint Vincent and the Grenadines",
        "TITLE_FR": "Saint-Vincent-et-les-Grenadines",
        "TITLE_ES": "San Vicente y las Granadinas",
        "TITLE_RU": "Сент-Винсент и Гренадины",
        "TITLE_ZH": "圣文森特和格林纳丁斯",
        "TITLE_AR": "سانت فنسنت وجزر غرينادين",
        "CODE": "VC"
    },
    {
        "TITLE_EN": "Samoa",
        "TITLE_FR": "Samoa",
        "TITLE_ES": "Samoa",
        "TITLE_RU": "Самоа",
        "TITLE_ZH": "萨摩亚",
        "TITLE_AR": "ساموا",
        "CODE": "WS"
    },
    {
        "TITLE_EN": "San Marino",
        "TITLE_FR": "Saint-Marin",
        "TITLE_ES": "San Marino",
        "TITLE_RU": "Сан-Марино",
        "TITLE_ZH": "圣马力诺",
        "TITLE_AR": "سان مارينو",
        "CODE": "SM"
    },
    {
        "TITLE_EN": "Sao Tome and Principe",
        "TITLE_FR": "Sao Tomé-et-Principe",
        "TITLE_ES": "Santo Tomé y Príncipe",
        "TITLE_RU": "Сан-Томе и Принсипи",
        "TITLE_ZH": "圣多美和普林西比",
        "TITLE_AR": "سان تومي وبرينسيبي",
        "CODE": "ST"
    },
    {
        "TITLE_EN": "Saudi Arabia",
        "TITLE_FR": "Arabie saoudite",
        "TITLE_ES": "Arabia Saudita",
        "TITLE_RU": "Саудовская Аравия",
        "TITLE_ZH": "沙特阿拉伯",
        "TITLE_AR": "المملكة العربية السعودية",
        "CODE": "SA"
    },
    {
        "TITLE_EN": "Senegal",
        "TITLE_FR": "Sénégal",
        "TITLE_ES": "Senegal",
        "TITLE_RU": "Сенегал",
        "TITLE_ZH": "塞内加尔",
        "TITLE_AR": "السنغال",
        "CODE": "SN"
    },
    {
        "TITLE_EN": "Serbia",
        "TITLE_FR": "Serbie",
        "TITLE_ES": "Serbia",
        "TITLE_RU": "Сербия",
        "TITLE_ZH": "塞尔维亚",
        "TITLE_AR": "صربيا",
        "CODE": "RS"
    },
    {
        "TITLE_EN": "Seychelles",
        "TITLE_FR": "Seychelles",
        "TITLE_ES": "Seychelles",
        "TITLE_RU": "Сейшельские Острова",
        "TITLE_ZH": "塞舌尔",
        "TITLE_AR": "سيشيل",
        "CODE": "SC"
    },
    {
        "TITLE_EN": "Sierra Leone",
        "TITLE_FR": "Sierra Leone",
        "TITLE_ES": "Sierra Leona",
        "TITLE_RU": "Сьерра-Леоне",
        "TITLE_ZH": "塞拉利昂",
        "TITLE_AR": "سيراليون",
        "CODE": "SL"
    },
    {
        "TITLE_EN": "Singapore",
        "TITLE_FR": "Singapour",
        "TITLE_ES": "Singapur",
        "TITLE_RU": "Сингапур",
        "TITLE_ZH": "新加坡",
        "TITLE_AR": "سنغافورة",
        "CODE": "SG"
    },
    {
        "TITLE_EN": "Slovakia",
        "TITLE_FR": "Slovaquie",
        "TITLE_ES": "Eslovaquia",
        "TITLE_RU": "Словакия",
        "TITLE_ZH": "斯洛伐克",
        "TITLE_AR": "سلوفاكيا",
        "CODE": "SK"
    },
    {
        "TITLE_EN": "Slovenia",
        "TITLE_FR": "Slovénie",
        "TITLE_ES": "Eslovenia",
        "TITLE_RU": "Словения",
        "TITLE_ZH": "斯洛文尼亚",
        "TITLE_AR": "سلوفينيا",
        "CODE": "SI"
    },
    {
        "TITLE_EN": "Solomon Islands",
        "TITLE_FR": "Iles Salomon",
        "TITLE_ES": "Islas Salom¢n",
        "TITLE_RU": "Соломоновы Острова",
        "TITLE_ZH": "所罗门群岛",
        "TITLE_AR": "جزر سليمان",
        "CODE": "SB"
    },
    {
        "TITLE_EN": "Somalia",
        "TITLE_FR": "Somalie",
        "TITLE_ES": "Somalia",
        "TITLE_RU": "Сомали",
        "TITLE_ZH": "索马里",
        "TITLE_AR": "الصومال",
        "CODE": "SO"
    },
    {
        "TITLE_EN": "South Africa",
        "TITLE_FR": "Afrique du Sud",
        "TITLE_ES": "Sudáfrica",
        "TITLE_RU": "Южная Африка",
        "TITLE_ZH": "南非",
        "TITLE_AR": "جنوب أفريقيا",
        "CODE": "ZA"
    },
    {
        "TITLE_EN": "South Sudan",
        "TITLE_FR": "Soudan du Sud",
        "TITLE_ES": "Sud n del Sur",
        "TITLE_RU": "Южный Судан",
        "TITLE_ZH": "南苏丹",
        "TITLE_AR": "جنوب السودان",
        "CODE": "SS"
    },
    {
        "TITLE_EN": "Spain",
        "TITLE_FR": "Espagne",
        "TITLE_ES": "España",
        "TITLE_RU": "Испания",
        "TITLE_ZH": "西班牙",
        "TITLE_AR": "إسبانيا",
        "CODE": "ES"
    },
    {
        "TITLE_EN": "Sri Lanka",
        "TITLE_FR": "Sri Lanka",
        "TITLE_ES": "Sri Lanka",
        "TITLE_RU": "Шри-Ланка",
        "TITLE_ZH": "斯里兰卡",
        "TITLE_AR": "سري لانكا",
        "CODE": "LK"
    },
    {
        "TITLE_EN": "Sudan",
        "TITLE_FR": "Soudan",
        "TITLE_ES": "Sudán",
        "TITLE_RU": "Судан",
        "TITLE_ZH": "苏丹",
        "TITLE_AR": "السودان",
        "CODE": "SD"
    },
    {
        "TITLE_EN": "Suriname",
        "TITLE_FR": "Suriname",
        "TITLE_ES": "Suriname",
        "TITLE_RU": "Суринам",
        "TITLE_ZH": "苏里南",
        "TITLE_AR": "سورينام",
        "CODE": "SR"
    },
    {
        "TITLE_EN": "Sweden",
        "TITLE_FR": "Suède",
        "TITLE_ES": "Suecia",
        "TITLE_RU": "Швеция",
        "TITLE_ZH": "瑞典",
        "TITLE_AR": "السويد",
        "CODE": "SE"
    },
    {
        "TITLE_EN": "Switzerland",
        "TITLE_FR": "Suisse",
        "TITLE_ES": "Suiza",
        "TITLE_RU": "Швейцария",
        "TITLE_ZH": "瑞士",
        "TITLE_AR": "سويسرا",
        "CODE": "CH"
    },
    {
        "TITLE_EN": "Syrian Arab Republic",
        "TITLE_FR": "République arabe syrienne",
        "TITLE_ES": "República Árabe Siria",
        "TITLE_RU": "Сирийская Арабская Республика",
        "TITLE_ZH": "阿拉伯叙利亚共和国",
        "TITLE_AR": "الجمهورية العربية السورية",
        "CODE": "SY"
    },
    {
        "TITLE_EN": "Tajikistan",
        "TITLE_FR": "Tadjikistan",
        "TITLE_ES": "Tayikistán",
        "TITLE_RU": "Таджикистан",
        "TITLE_ZH": "塔吉克斯坦",
        "TITLE_AR": "طاجيكستان",
        "CODE": "TJ"
    },
    {
        "TITLE_EN": "Thailand",
        "TITLE_FR": "Thaïlande",
        "TITLE_ES": "Tailandia",
        "TITLE_RU": "Таиланд",
        "TITLE_ZH": "泰国",
        "TITLE_AR": "تايلند",
        "CODE": "TH"
    },
    {
        "TITLE_EN": "Timor-Leste",
        "TITLE_FR": "Timor-Leste",
        "TITLE_ES": "Timor-Leste",
        "TITLE_RU": "Тимор-Лешти",
        "TITLE_ZH": "东帝汶",
        "TITLE_AR": "تيمور - ليشتي",
        "CODE": "TL"
    },
    {
        "TITLE_EN": "Togo",
        "TITLE_FR": "Togo",
        "TITLE_ES": "Togo",
        "TITLE_RU": "Того",
        "TITLE_ZH": "多哥",
        "TITLE_AR": "توغو",
        "CODE": "TG"
    },
    {
        "TITLE_EN": "Tonga",
        "TITLE_FR": "Tonga",
        "TITLE_ES": "Tonga",
        "TITLE_RU": "Тонга",
        "TITLE_ZH": "汤加",
        "TITLE_AR": "تونغا",
        "CODE": "TO"
    },
    {
        "TITLE_EN": "Trinidad and Tobago",
        "TITLE_FR": "Trinité-et-Tobago",
        "TITLE_ES": "Trinidad y Tabago",
        "TITLE_RU": "Тринидад и Тобаго",
        "TITLE_ZH": "特立尼达和多巴哥",
        "TITLE_AR": "ترينيداد وتوباغو",
        "CODE": "TT"
    },
    {
        "TITLE_EN": "Tunisia",
        "TITLE_FR": "Tunisie",
        "TITLE_ES": "Túnez",
        "TITLE_RU": "Тунис",
        "TITLE_ZH": "突尼斯",
        "TITLE_AR": "تونس",
        "CODE": "TN"
    },
    {
        "TITLE_EN": "Türkiye",
        "TITLE_FR": "Türkiye",
        "TITLE_ES": "Türkiye",
        "TITLE_RU": "Турция",
        "TITLE_ZH": "土耳其",
        "TITLE_AR": "تركيا",
        "CODE": "TR"
    },
    {
        "TITLE_EN": "Turkmenistan",
        "TITLE_FR": "Turkménistan",
        "TITLE_ES": "Turkmenistán",
        "TITLE_RU": "Туркменистан",
        "TITLE_ZH": "土库曼斯坦",
        "TITLE_AR": "تركمانستان",
        "CODE": "TM"
    },
    {
        "TITLE_EN": "Tuvalu",
        "TITLE_FR": "Tuvalu",
        "TITLE_ES": "Tuvalu",
        "TITLE_RU": "Тувалу",
        "TITLE_ZH": "图瓦卢",
        "TITLE_AR": "توفالو",
        "CODE": "TV"
    },
    {
        "TITLE_EN": "Uganda",
        "TITLE_FR": "Ouganda",
        "TITLE_ES": "Uganda",
        "TITLE_RU": "Уганда",
        "TITLE_ZH": "乌干达",
        "TITLE_AR": "أوغندا",
        "CODE": "UG"
    },
    {
        "TITLE_EN": "Ukraine",
        "TITLE_FR": "Ukraine",
        "TITLE_ES": "Ucrania",
        "TITLE_RU": "Украина",
        "TITLE_ZH": "乌克兰",
        "TITLE_AR": "أوكرانيا",
        "CODE": "UA"
    },
    {
        "TITLE_EN": "United Arab Emirates",
        "TITLE_FR": "Émirats arabes unis",
        "TITLE_ES": "Emiratos Árabes Unidos",
        "TITLE_RU": "Объединенные Арабские Эмираты",
        "TITLE_ZH": "阿拉伯联合酋长国",
        "TITLE_AR": "الإمارات العربية المتحدة",
        "CODE": "AE"
    },
    {
        "TITLE_EN": "United Kingdom",
        "TITLE_FR": "Royaume-Uni",
        "TITLE_ES": "Reino Unido",
        "TITLE_RU": "Соединенное Королевство",
        "TITLE_ZH": "联合王国",
        "TITLE_AR": "المملكة المتحدة",
        "CODE": "GB"
    },
    {
        "TITLE_EN": "United Republic of Tanzania",
        "TITLE_FR": "République-Unie de Tanzanie",
        "TITLE_ES": "República Unida de Tanzanía ",
        "TITLE_RU": "Объединенная Республика Танзания",
        "TITLE_ZH": "坦桑尼亚联合共和国",
        "TITLE_AR": "جمهورية تنزانيا المتحدة",
        "CODE": "TZ"
    },
    {
        "TITLE_EN": "United States of America",
        "TITLE_FR": "Etats-Unis d'Amérique",
        "TITLE_ES": "Estados Unidos de América ",
        "TITLE_RU": "Соединенные Штаты Америки",
        "TITLE_ZH": "美利坚合众国",
        "TITLE_AR": "الولايات المتحدة الأمريكية",
        "CODE": "US"
    },
    {
        "TITLE_EN": "Uruguay",
        "TITLE_FR": "Uruguay",
        "TITLE_ES": "Uruguay",
        "TITLE_RU": "Уругвай",
        "TITLE_ZH": "乌拉圭",
        "TITLE_AR": "أوروغواي",
        "CODE": "UY"
    },
    {
        "TITLE_EN": "Uzbekistan",
        "TITLE_FR": "Ouzbékistan",
        "TITLE_ES": "Uzbekistán",
        "TITLE_RU": "Узбекистан",
        "TITLE_ZH": "乌兹别克斯坦",
        "TITLE_AR": "أوزبكستان",
        "CODE": "UZ"
    },
    {
        "TITLE_EN": "Vanuatu",
        "TITLE_FR": "Vanuatu",
        "TITLE_ES": "Vanuatu",
        "TITLE_RU": "Вануату",
        "TITLE_ZH": "瓦努阿图",
        "TITLE_AR": "فانواتو",
        "CODE": "VU"
    },
    {
        "TITLE_EN": "Venezuela (Bolivarian Republic of)",
        "TITLE_FR": "Venezuela (République bolivarienne du)",
        "TITLE_ES": "Venezuela (República Bolivariana de)",
        "TITLE_RU": "Венесуэла(Боливарианская Республика Венесуэла)",
        "TITLE_ZH": "委内瑞拉（玻利瓦尔共和国）",
        "TITLE_AR": "فنزويلا(جمهورية - البوليفارية)",
        "CODE": "VE"
    },
    {
        "TITLE_EN": "Viet Nam",
        "TITLE_FR": "Viet Nam",
        "TITLE_ES": "Viet Nam",
        "TITLE_RU": "Вьетнам",
        "TITLE_ZH": "越南",
        "TITLE_AR": "فييت نام",
        "CODE": "VN"
    },
    {
        "TITLE_EN": "Yemen",
        "TITLE_FR": "Yémen",
        "TITLE_ES": "Yemen",
        "TITLE_RU": "Йемен",
        "TITLE_ZH": "也门",
        "TITLE_AR": "اليمن",
        "CODE": "YE"
    },
    {
        "TITLE_EN": "Zambia",
        "TITLE_FR": "Zambie",
        "TITLE_ES": "Zambia",
        "TITLE_RU": "Замбия",
        "TITLE_ZH": "赞比亚",
        "TITLE_AR": "زامبيا",
        "CODE": "ZM"
    },
    {
        "TITLE_EN": "Zimbabwe",
        "TITLE_FR": "Zimbabwe",
        "TITLE_ES": "Zimbabwe",
        "TITLE_RU": "Зимбабве",
        "TITLE_ZH": "津巴布韦",
        "TITLE_AR": "زمبابوي",
        "CODE": "ZW"
    },
    {
        "TITLE_EN": "",
        "TITLE_FR": "",
        "TITLE_ES": "",
        "TITLE_RU": "",
        "TITLE_ZH": "",
        "TITLE_AR": ""
    }
]